import React, { useState } from "react";
import { FaHospital } from "react-icons/fa";
import { motion } from "framer-motion";
import MedOrg from "../components/products/MedOrg"; // Import your MedOrg component
import "../css/Products.css";

export default function Products() {
  const [showMedOrg, setShowMedOrg] = useState(false);

  const products = [
    {
      icon: <FaHospital />,
      title: "MedOrg",
      desc:
        "A modern healthcare management system that streamlines hospital workflows, patient records, and healthcare operations.",
      points: [
        "Patient management and medical records",
        "Staff scheduling and hospital resources",
        "Billing, insurance, and financial tracking",
        "Advanced reporting and analytics",
      ],
    },
  ];

  // If user clicked MedOrg, render the MedOrg component
  if (showMedOrg) {
    return <MedOrg />;
  }

  return (
    <section className="products">
      <div className="products-bg" />

      <div className="products-wrapper">
        {/* Header */}
        <div className="products-header">
          <span className="products-label">Our Products</span>

          <h2 className="products-title">
            Software Designed for <span>Modern Institutions</span>
          </h2>

          <p className="products-lead">
            We build focused, modular systems that help institutions operate efficiently, communicate clearly, and make informed decisions.
          </p>
        </div>

        {/* Grid */}
        <div className="products-grid">
          {products.map((item, index) => (
            <motion.div
              key={index}
              className={`product-card ${item.title === "MedOrg" ? "medorg" : ""}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.12 }}
              viewport={{ once: true }}
              onClick={() => {
                if (item.title === "MedOrg") setShowMedOrg(true);
              }}
              style={{ cursor: "pointer" }} // indicate clickable
            >
              <div className="product-icon">{item.icon}</div>

              <h3 className="product-title">{item.title}</h3>

              <p className="product-desc">{item.desc}</p>

              <ul className="product-points">
                {item.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
